module.exports = __webpack_public_path__ + "img/climbing.6aeca5be.jpg";